import React, { useState } from 'react';
import {
  makeStyles,
  createStyles,
  Theme,
} from '@material-ui/core';
import {
  ToggleButtonGroup,
  ToggleButton as MuiToggleButton,
} from '@material-ui/lab';
import { ToggleButtonProps } from './types';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    toggleGroup: {
      backgroundColor: theme.palette.type === 'dark' ? 'rgba(255, 255, 255, 0.08)' : '#DFE6E5',
      borderRadius: '24px',
      height: '40px',
    },
    toggleButton: {
      padding: theme.spacing(0.5, 1.5),
      textTransform: 'none',
      fontWeight: 400,
      border: 'none',
      fontSize: '0.75rem',
      whiteSpace: 'nowrap',
      color: theme.palette.text.secondary,
      backgroundColor: 'transparent',
      '&.Mui-selected': {
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        borderRadius: '20px !important',
        '&:hover': {
          backgroundColor: theme.palette.action.hover,
        },
      },
    },
  }),
);

export const ToggleButton: React.FC<ToggleButtonProps> = ({
  options = [
    { value: 'similar', label: 'By Similar prompts' },
    { value: 'user', label: 'By user' },
  ],
  value,
  onChange,
  className = '',
}) => {
  const classes = useStyles();
  const [selectedValue, setSelectedValue] = useState(value || options[0]?.value);

  const handleToggle = (
    event: React.MouseEvent<HTMLElement>,
    newValue: string | null,
  ) => {
    if (newValue !== null) {
      setSelectedValue(newValue);
      onChange?.(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={selectedValue}
      exclusive
      onChange={handleToggle}
      className={`${classes.toggleGroup} ${className}`}
    >
      {options.map((option) => (
        <MuiToggleButton
          key={option.value}
          value={option.value}
          className={classes.toggleButton}
        >
          {option.label}
        </MuiToggleButton>
      ))}
    </ToggleButtonGroup>
  );
};
